import type { Resource } from '../../';
export const order_orderSummary_discount: Resource = {"default":"Discount"};
